import Cookies from 'js-cookie';
export default {
  state: {
    ACCOUNT_TYPES: {
      1: '订阅号',
      2: '服务号'
    },
    wxAccountList: [],
    selectedAppid: ''
  },
  mutations: {
    updateAccountList(state, list) {
      state.wxAccountList = list
    },
    updateSelectedAppid(state,appid){
      state.selectedAppid = appid;
      Cookies.set('appid', appid);
    },
    /*selectAccount(state, appid) {
      //废弃 todo
      state.selectedAppid = appid
      if (oldAppid) {//切换账号时刷新网页
        location.reload();
      }
    },*/
  },
  getters: {
    wxAccountList: state => state.wxAccountList,
    selectedAppid: state => state.selectedAppid,
  }
}
